import React from 'react';
import { whyChooseUs } from '../../data/ultimateData';

const UltimateWhyChoose = () => {
 const scrollToForm = () => {
 const formSection = document.getElementById('contact-form-section');
 if (formSection) formSection.scrollIntoView({ behavior: 'smooth', block: 'center' });
 };

 return (
 <section className="relative py-16 sm:py-24 overflow-hidden" data-testid="why-choose-section" id="why-choose-section" style={{ background: "linear-gradient(180deg, rgba(9,9,12,0.94) 0%, rgba(9,9,12,0.90) 50%, rgba(9,9,12,0.96) 100%), url('/img/2581f64d.webp') center/cover no-repeat fixed" }}>
 
 {/* Background Effects - Purple */}
 <div className="absolute inset-0">
 <div className="absolute top-1/4 left-0 w-80 h-80 bg-[#d4a84b]/8 rounded-full blur-3xl" />
 <div className="absolute bottom-1/4 right-0 w-72 h-72 bg-[#d4a84b]/8 rounded-full blur-3xl" />
 </div>
 
 <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">

 {/* Section Header */}
 <div className="text-center mb-12">
 <span className="inline-block tracking-[0.3em] text-[#C9A23A] font-bold text-sm mb-3 uppercase">
 हमें क्यों चुनें
 </span>
 <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 <span className="">
 माता मलीहा ही क्यों?
 </span>
 </h2>
 <p className="text-[#D8D2C6] text-lg max-w-2xl mx-auto">
 25+ वर्षों का अनुभव और <span className="text-[#F3EDE2] font-bold">97% सफलता दर</span> - यही है हमारी पहचान
 </p>
 </div>

 {/* Features Grid */}
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
 {whyChooseUs.map((item, index) => (
 <div
 key={index}
 className="p-6 rounded-2xl bg-gradient-to-br from-[#17171C] to-[#101014] border border-[#d4a84b]/20 hover:border-[#d4a84b]/40 transition-all group"
 >
 <div className="text-4xl mb-4 group-hover:scale-110 transition-transform">{item.icon}</div>
 <h3 className="text-xl font-bold mb-2" style={{ fontFamily: "'Rozha One', serif" }}>
 {item.title}
 </h3>
 <p className="text-[#D8D2C6]/80 text-sm leading-relaxed">{item.description}</p>
 </div>
 ))}
 </div>

 {/* Comparison Table */}
 <div className="max-w-4xl mx-auto mb-12">
 <h3 className="text-2xl font-bold text-center text-[#D8D2C6] mb-6" style={{ fontFamily: "'Rozha One', serif" }}>
 माता मलीहा vs अन्य तांत्रिक
 </h3>
 <div className="overflow-x-auto rounded-xl border border-[#d4a84b]/20">
 <table className="w-full">
 <thead>
 <tr className="border-b border-[#d4a84b]/60 bg-[#0B0B0E] border border-[#d4a84b]/40">
 <th className="text-left py-4 px-4 text-[#D8D2C6] font-medium">विशेषता</th>
 <th className="text-center py-4 px-4 text-[#F3EDE2] font-bold">माता मलीहा</th>
 <th className="text-center py-4 px-4 text-[#D8D2C6]/50 font-medium">अन्य</th>
 </tr>
 </thead>
 <tbody>
 {[
 ['पहली जाँच', 'क्षमतानुसार दक्षिणा', '₹500-2000'],
 ['सफलता दर', '97%', '40-50%'],
 ['अनुभव', '25+ वर्ष', '5-10 वर्ष'],
 ['परची से नाम', 'हाँ, बता देंगी', 'नहीं'],
 ['गोपनीयता', '100%', 'संदिग्ध'],
 ['Follow-up', 'साधना बाद शामिल', 'अलग से'],
 ].map((row, i) => (
 <tr key={i} className="border-b border-[#d4a84b]/10">
 <td className="py-4 px-4 text-[#D8D2C6]">{row[0]}</td>
 <td className="py-4 px-4 text-center text-[#E2C170] font-bold">{row[1]}</td>
 <td className="py-4 px-4 text-center text-[#D8D2C6]/50">{row[2]}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </div>

 {/* CTA */}
 <div className="text-center">
 <button
 onClick={scrollToForm}
 className="px-10 py-4 bg-gradient-to-r from-[#f5d77e] to-[#d4a84b] hover:from-[#f5d77e] hover:to-[#f5d77e] text-black text-lg font-black rounded-full shadow-xl shadow-amber-500/30 hover:scale-105 transition-all"
 style={{ fontFamily: "'Rozha One', serif" }}
 >
 अभी माता जी से बात करें - क्षमतानुसार
 </button>
 
 {/* Aghori Disclaimer */}
 <div className="mt-6 p-4 rounded-xl bg-[#17171C] border border-[#5c1a1a] max-w-2xl mx-auto">
 <p className="text-[#F3EDE2] font-bold text-sm">
 ❖ <span className="text-[#F3EDE2]">अघोर विधि</span> से कार्य होता है। पूरी श्रद्धा-विश्वास हो तभी आएं। जिन्हें विश्वास नहीं, कृपया दूर रहें।
 </p>
 <p className="text-[#F3EDE2] font-bold text-sm mt-1">
 ! छल-कपट, दुर्भाव से ना आएं - अच्छे मन से आएं ताकि कार्य सफल हो।
 </p>
 </div>
 </div>
 </div>
 </section>
 );
};

export default UltimateWhyChoose;
